/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateProfileSectionSchema = z.enum(['work_history', 'education', 'licenses'])

export type CandidateProfileSectionSchema = z.infer<typeof candidateProfileSectionSchema>
